"use strict";
import React from "react";

const ApiDocumentation = () => {
    return <div>API Documentation</div>;
};

export default ApiDocumentation;
